import React from 'react';
import PropTypes, { string } from 'prop-types';
import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import { useTranslation } from 'react-i18next';
import { internationalizeDate, mlb, browser } from 'yankees-react-utils';
import { useBlobDownloadQuery, usePlayerGamesQuery } from '../../data';
import { headerHeight, headerPaddingLeftRight } from '../SectionContentContainer';

const StyledTeamSeriesHeader = styled.div`
    flex-grow: 0;
    display: flex;
    align-items: center;
    height: ${headerHeight};
    padding: 5px ${headerPaddingLeftRight};
    background-color: ${({ $backgroundColor }) => ($backgroundColor || '#333')};
    color: white;
    img {
        height: 100%;
    }
    h3, p, h3 > span {
        margin: 1px 10px;
    }
    p {
        text-transform: uppercase;
    }
`;

const TeamSeriesHeader = ({ teamId, team, isDugout }) => {
    if (isDugout) {
        return <TeamSeriesHeaderDugout teamId={teamId} team={team} />;
    }

    return <TeamSeriesHeaderPortal teamId={teamId} team={team} />;
};

const TeamSeriesHeaderPortal = ({ teamId, team }) => {
    const { t: translate } = useTranslation();
    const { src: logoSrc } = useBlobDownloadQuery(`/api/team/${teamId}/logo`);
    const { series } = usePlayerGamesQuery();

    const teamSeries = series?.find(({ TeamID }) => TeamID.toString() === teamId.toString());
    return (
        <StyledTeamSeriesHeader $backgroundColor={mlb.backgrounds[teamId]}>
            <Image src={logoSrc} />
            { !browser.mobileOnly && (
                <div>
                    {teamSeries && <p>{teamSeries.isCurrentSeries ? translate('home.series-current') : translate('home.series-upcoming')}</p>}
                    <h3>
                        {team?.City}
                        {teamSeries && (<span>{internationalizeDate(translate, new Date(teamSeries.startDate), false, false, true, true, false, false, false, false)} - {internationalizeDate(translate, new Date(teamSeries.endDate), false, false, true, true, false, false, false, false)}</span>)}
                    </h3>
                </div>
            )}
            { browser.mobileOnly && (
                <div>
                    {teamSeries && (<><p>{teamSeries.isCurrentSeries ? translate('home.series-current') : translate('home.series-upcoming')}{translate('format.datetime', { val: new Date(teamSeries.startDate), formatParams: { val: { month: 'numeric', day: 'numeric' } }, interpolation: { escapeValue: false } })} - {translate('format.datetime', { val: new Date(teamSeries.endDate), formatParams: { val: { month: 'numeric', day: 'numeric' } }, interpolation: { escapeValue: false } })}</p></>)}
                    <h3>
                        {team?.City}
                    </h3>
                </div>
            )}
        </StyledTeamSeriesHeader>
    );
};

const TeamSeriesHeaderDugout = ({ teamId, team }) => {
    const { src: logoSrc } = useBlobDownloadQuery(`/api/team/${teamId}/logo`);

    return (
        <StyledTeamSeriesHeader $backgroundColor={mlb.backgrounds[teamId]}>
            <Image src={logoSrc} />
            <div>
                <h3>
                    {team?.FullName}
                </h3>
            </div>
        </StyledTeamSeriesHeader>
    );
};

TeamSeriesHeader.propTypes = {
    teamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    team: PropTypes.shape({
        City: string,
        FullName: string,
    }),
    isDugout: PropTypes.bool,
};

TeamSeriesHeader.defaultProps = {
    team: undefined,
    isDugout: false,
};

export default TeamSeriesHeader;
